export default "__VITE_ASSET__CBrEmFQH__"